import { RouteRecordRaw } from 'vue-router';
import { requireProvider } from '@/router/guards/authGuards';

const photoUploadRoutes: RouteRecordRaw[] = [
  {
    path: '/account/provider/photo',
    name: 'provider-photo-upload',
    component: () => import('@/apps/account/provider/photo/AccountProviderPhoto.vue'),
    beforeEnter: requireProvider,
  },
];

export default photoUploadRoutes;
